var rich_content_viewer_default = {
  "fontElementMap": "_3n4LP",
  "wrapper": "_9Omqz",
  "pluginContainerMobile": "kwAwd",
  "viewer": "qegG4",
  "android": "Qbgl4",
  "rootedTraversedContent": "Io-tr",
  "atomic": "KIcHr",
  "toolbar": "_6E-ae",
  "block": "Vhc6T"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
